module.exports = __webpack_public_path__ + "static/section-5-img-2-c32bc768dcb63832d500a994da8b7339.png";